import React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import { object, string } from 'prop-types';

import { getIsNewSeller } from '../../utils/sellerHelpers';

import { PdpSharedNewSellerPill } from '../PdpSharedNewSellerPill/PdpSharedNewSellerPill';

import styles from './PdpSharedDealerDetailsHeader.scss';

export function PdpSharedDealerDetailsHeaderComponent(props) {
    const { seller, user, headerClass, viewer } = props;
    const canShowSellerName = get(user, 'canShowSellerName');
    const monthsSinceStartDate = get(seller, 'monthsSinceStartDate');
    const isNewSeller = getIsNewSeller(monthsSinceStartDate);
    const isNewSellerPillEnabled = get(viewer, 'isNewSellerPillEnabled');

    let detailsHeader;

    if (canShowSellerName) {
        detailsHeader = get(seller, 'sellerProfile.company');
    } else {
        detailsHeader = (
            <FormattedMessage
                id="PdpSharedDealerDetailsHeader.seller_title"
                defaultMessage="About the Seller"
            />
        );
    }

    return (
        <React.Fragment>
            <h2 className={headerClass} data-tn="pdp-shared-dealer-details-header">
                {detailsHeader}
            </h2>
            {isNewSeller &&
                isNewSellerPillEnabled && (
                    <span className={styles.pill}>
                        <PdpSharedNewSellerPill />
                    </span>
                )}
        </React.Fragment>
    );
}

PdpSharedDealerDetailsHeaderComponent.propTypes = {
    headerClass: string,
    seller: object,
    user: object,
    viewer: object,
};

export const PdpSharedDealerDetailsHeader = createFragmentContainer(
    PdpSharedDealerDetailsHeaderComponent,
    {
        viewer: graphql`
            fragment PdpSharedDealerDetailsHeader_viewer on Viewer {
                isNewSellerPillEnabled: isEnabled(key: "enableNewSellerPill")
            }
        `,
        user: graphql`
            fragment PdpSharedDealerDetailsHeader_user on User {
                canShowSellerName
            }
        `,
        seller: graphql`
            fragment PdpSharedDealerDetailsHeader_seller on Seller {
                monthsSinceStartDate: timeSinceStartDate(unit: MONTH)
                sellerProfile {
                    company
                }
            }
        `,
    }
);
